import Image from "next/image";
import { makeStyles } from "@mui/styles";
import React from "react";
const useStyles = makeStyles(() => ({
  userReaction: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
    fontSize: "12px",
    color: "#0000008a",
    position:"relative",
    paddingLeft:"30px",
    marginLeft:"15px",
    "&::before": {
        width: "30px",
        content: "''",
        backgroundImage: "url('/images/community/reply-line.svg')",
        position: "absolute",
        height: "16px",
        left: "0px",
        top: "10px"
      },
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
    background:
      "-webkit-linear-gradient(90.78deg, #b237f6 3.91%, #e94177 96.03%)",
    "-webkitBackgroundClip": "text",
    "-webkitTextFillColor": "transparent",
    fontWeight:"600"
  },
  userImg: {
    height: "16px",
    width: "16px",
    borderRadius: "50%",
    position:"relative",
    overflow:"hidden",
    '& img':{
      maxWidth:"initial"
    },
  },
}));
const ParentMessage = ({ item }) => {
  const classes = useStyles();
  return (
    <>
      {item?.parentId && (
        <div className={classes.userReaction}>
          <div className={classes.userInfo}>
            {item?.parentId?.user?.profilePic && (
              <div className={classes.userImg}>
                <Image
                  alt=""
                  src={item?.parentId?.user?.profilePic}
                  layout="fill"
                />
              </div>
            )}
            {item?.parentId?.user?.name && "@" + item?.parentId?.user?.name}
          </div>
          {item?.parentId?.text?.length > 80
            ? item?.parentId?.text?.slice(0, 80) + "..."
            : item?.parentId?.text}
        </div>
      )}
    </>
  );
};

export default ParentMessage;
